module.exports = __webpack_public_path__ + "assets/img/ashton.476a0cb5.jpg";